import { API_CONFIG, apiUtils } from '../config.js';

// Calendar Management API
export const calendarApi = {
  // Create calendar event
  createEvent: async (eventData) => {
    const url = `${API_CONFIG.BASE_URL}/calendar/create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(eventData),
    });
  },

  // Update calendar event
  updateEvent: async (eventId, eventData) => {
    const url = `${API_CONFIG.BASE_URL}/calendar/update/${eventId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(eventData),
    });
  },

  // Delete calendar event
  deleteEvent: async (eventId) => {
    try {
      const token = localStorage.getItem('authToken');
      const headers = {
        ...(token && { 'Authorization': `Bearer ${token}` })
      };

      const response = await fetch(`${API_CONFIG.BASE_URL}/calendar/delete/${eventId}`, {
        method: 'DELETE',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { success: true };
    } catch (error) {
      apiUtils.handleError(error);
      throw error;
    }
  },

  // Get calendar events by range
  getEventsByRange: async (fromDate, toDate) => {
    const queryParams = apiUtils.buildQueryString({ from: fromDate, to: toDate });
    const url = `${API_CONFIG.BASE_URL}/calendar/range?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get calendar event by ID
  getEventById: async (eventId) => {
    const url = `${API_CONFIG.BASE_URL}/calendar/by-id/${eventId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get calendar events by month
  getEventsByMonth: async (month) => {
    const queryParams = apiUtils.buildQueryString({ month });
    const url = `${API_CONFIG.BASE_URL}/calendar/month?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get calendar events by type
  getEventsByType: async (type, filters = {}) => {
    const queryParams = apiUtils.buildQueryString({ type, ...filters });
    const url = `${API_CONFIG.BASE_URL}/calendar/type?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get upcoming events
  getUpcomingEvents: async (days = 7) => {
    const queryParams = apiUtils.buildQueryString({ days });
    const url = `${API_CONFIG.BASE_URL}/calendar/upcoming?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get calendar statistics
  getCalendarStatistics: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/calendar/statistics?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },
};

export default calendarApi;
